import dynamic from "next/dynamic";
import Icons from "../Shared/IconsImport";

const ProductHeader = dynamic(import("../Header/ProductHeader"));
const GeneralFooter = dynamic(import("../Footer/GeneralFooter"));

export default function CampaignLayout(props) {
	return (
		<>
			<Icons />
			<div className="campaign-layout">
				<ProductHeader
					nav={props.nav}
					logo={props.logo}
				/>
				{/* Build Navigation */}
				{props.children}
				{props.footer !== false && <GeneralFooter footer={props.footer} />}
			</div>
		</>
	);
}